<template>
  <div class="">
    <div class="row topactionform smallmargin">
      <div class="col-xs-10">
        <div class="smalltitle">EPCS Log</div>
      </div>
    </div>
    <div class="blockcont">
      <ul class="itemlisttable">
        <li class="item-block itemlisthead">
          <div class="item-date"><b>Date</b></div>
          <div class="item-doctor">
            <dropdown :ref="'dropdown_provider_search'"
                      :not-close-elements="dropDownNotClose"
                      append-to-body
                      class="dropdown"
                      menu-left
            >
              <a data-toggle="dropdown" href="javascript:void(0)"
                 title="Click to search by provider name"><i class="fas fa-search" style="font-size:11px; margin-right: 5px !important;"></i> <b>Provider</b></a>
              <template slot="dropdown">
                <input v-model="filter.doctorName" class="keyinput"
                       style="width: auto !important;" type="text"
                       @change="getListHistories()"/>
              </template>
            </dropdown>
          </div>
          <div class="item-type"><b>Type</b></div>
          <div class="item-action"><b>Action</b></div>
          <div class="item-user">
            <dropdown :ref="'dropdown_user_search'"
                      :not-close-elements="dropDownNotClose"
                      append-to-body
                      class="dropdown"
                      menu-left
            >
              <a data-toggle="dropdown" href="javascript:void(0)"
                 title="Click to search by provider name"><i class="fas fa-search" style="font-size:11px; margin-right: 5px !important;"></i> <b>User</b></a>
              <template slot="dropdown">
                <input v-model="filter.userName" class="keyinput"
                       style="width: auto !important;" type="text"
                       @change="getListHistories()"/>
              </template>
            </dropdown>
          </div>
        </li>
        <li v-for="item in histories" :key="item._id" class="list-item">
          <div class="item-date">{{ formatFullTime(item.createdAt) }}</div>
          <div class="item-doctor">{{ item.doctorName }}</div>
          <div class="item-type">{{ getTypeName(item) }}</div>
          <div class="item-action">
<!--            {{ getActionName(item) }}-->
            {{ getKindName(item) }}
            <div class="item-decline-reason" :title="item.declineReason" v-if="item.kind === 'decline'">
              ({{item.declineReason}})
            </div>
          </div>
          <div class="item-user">{{ item.user ? item.user.fullName : 'N/A' }}</div>
        </li>
      </ul>
    </div>
    <pagination :currentPage="paginate.page" :perPage="paginate.perPage" :total="paginate.total"
                :totalPages="paginate.totalPages" @updatePerPage="updatePerPage"></pagination>

    <div class="row topactionform smallmargin">
      <div class="col-xs-10">
        <div class="smalltitle">Incidents Log</div>
      </div>
    </div>
    <div class="blockcont">
      <ul class="itemlisttable">
        <li class="item-block itemlisthead">
          <div class="item-date"><b>Date</b></div>
          <div class="item-doctor"><b>Doctor</b></div>
          <div class="item-type"><b>User</b></div>
          <div class="item-type"><b>Reason</b></div>
          <div class="item-action"><b>File</b></div>
        </li>
        <li v-for="incidentsLog in incidentsLog" :key="incidentsLog._id" class="list-item">
          <div class="item-date">{{ formatFullTime(incidentsLog.createdAt) }}</div>
          <div class="item-doctor">{{ (incidentsLog.doctor ? incidentsLog.doctor.fullName : '') }}</div>
          <div class="item-type">{{ (incidentsLog.dataCreate ? incidentsLog.dataCreate.fullName : '') }}</div>
          <div class="item-type">{{ incidentsLog.reason }}</div>
          <div class="item-action">
            <a style="display: block" href="javascript:void(0)"
               v-for="file in incidentsLog.files" @click.prevent="showFile(file)">{{ file.fileName }}
            </a>
          </div>
        </li>
      </ul>
    </div>
    <pagination :currentPage="paginateIncidentsLog.page" :perPage="paginateIncidentsLog.perPage" :total="paginateIncidentsLog.total"
                :totalPages="paginateIncidentsLog.totalPages" @updatePerPage="updatePerPageIncidents"></pagination>

    <preview-pdf
        v-if="previewPdf.modal"
        :linkPreview="previewPdf.link"
        @updateModal="previewPdf.modal = $event">
    </preview-pdf>
  </div>
</template>

<script>
import httpClient from '@/client'
import Pagination from '@/global/Pagination.vue'
import CommonMixin from '@/mixins/general/CommonMixin.vue'
import Common from '../mixins/Common.vue'
import PreviewPdf from '@/global/PreviewPdf'
import config from '@/config'

const baseUrl = config.baseUrl
export default {
  name: 'LogEPCS',
  mixins: [CommonMixin, Common],
  components: { Pagination, PreviewPdf },
  data () {
    return {
      histories: [],
      filter: {
        doctorName: '',
        userName: ''
      },
      paginate: {
        perPage: 10,
        page: 1,
        totalPages: 10,
        total: 0
      },
      dropDownNotClose: [],
      showProviderSearch: false,

      incidentsLog: [],
      paginateIncidentsLog: {
        perPage: 10,
        page: 1,
        totalPages: 10,
        total: 0
      },
      previewPdf: {
        modal: false,
        link: ''
      }
    }
  },
  mounted () {
    this.getListHistories()
    this.getListIncidents()
  },
  methods: {
    getKindName (item) {
      if (item.kind === 'approval') {
        let array = ['First', 'Second']
        return `${array[item.order - 1]} approval`
      }
      if (item.kind === 'decline') {
        return 'Declined'
      }
      return 'Created'
    },
    getActionName (item) {
      if (item.kind === 'approval') {
        return 'Approved and verified'
      }
      return 'Created'
    },
    getTypeName (item) {
      return `${item.action === 'add' ? 'Add' : 'Remove'} Controlled Substance`
    },
    async getListHistories () {
      try {
        let params = {
          page: this.paginate.page,
          perPage: this.paginate.perPage,
          doctorName: this.filter.doctorName,
          userName: this.filter.userName
        }
        const response = await httpClient.get(`/surescript/approval-request-histories`, { params })
        if (response.data.s === 200) {
          this.histories = response.data.data.histories.data ? response.data.data.histories.data : []
          this.paginate.page = Number(response.data.data.histories.currentPage)
          this.paginate.total = response.data.data.histories.total
          this.paginate.totalPages = Math.ceil(this.paginate.total / this.paginate.perPage)
        } else {
          this.alertError(response.data.msg)
        }
        this.updateDropDown()
      } catch (e) {
        console.log('e', e.message)
        this.alertException(e)
      }
    },
    updatePerPage (data) {
      this.paginate.perPage = data.perPage
      this.paginate.page = data.currentPage
      this.getListHistories()
    },
    updateDropDown () {
      this.dropDownNotClose = []
      this.$nextTick(function () {
        this.dropDownNotClose.push(this.$refs.dropdown_provider_search.$el)
        this.dropDownNotClose.push(this.$refs.dropdown_user_search.$el)
      })
    },
    async getListIncidents () {
      try {
        let params = {
          page: this.paginateIncidentsLog.page,
          perPage: this.paginateIncidentsLog.perPage
        }
        const response = await httpClient.get(`/doctor/list-incidents-log`, { params })
        if (response.data.s === 200) {
          this.incidentsLog = response.data.data.incidentsLog.data ? response.data.data.incidentsLog.data : []
          this.paginateIncidentsLog.page = Number(response.data.data.incidentsLog.currentPage)
          this.paginateIncidentsLog.total = response.data.data.incidentsLog.total
          this.paginateIncidentsLog.totalPages = Math.ceil(this.paginateIncidentsLog.total / this.paginateIncidentsLog.perPage)
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        console.log('e', e.message)
        this.alertException(e)
      }
    },
    updatePerPageIncidents (data) {
      this.paginateIncidentsLog.perPage = data.perPage
      this.paginateIncidentsLog.page = data.currentPage
      this.getListIncidents()
    },
    showFile (file) {
      console.log('file', file)
      this.previewPdf.link = baseUrl + '/doctor/deactivate-epcs/file?mimeType=' + file.mimeType + '&path=' + file.serverPath + '&view=true'
      console.log('link', this.previewPdf.link)
      this.previewPdf.modal = true
    }
  }
}
</script>

<style scoped>
.text-color {
  color: red;
}

.svg-inline--fa {
  height: 1em;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid #dee2e6;
  border-radius: .25rem;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1rem;
}

.block-item-card {
  margin: 10px;
  display: block;
  float: left;
  width: 40%;
  height: 320px;
}

.block-item-card .card-header {
  background-color: #f8f9fa;
  padding: .5rem 1rem;
  margin-bottom: 0;
  border-bottom: 1px solid #dee2e6;
}

.block-item-card .card-footer {
  padding: .5rem 1rem;
  background-color: rgba(0, 0, 0, .03);
  border-top: 1px solid #dee2e6;
  width: 100%;
}

.text-muted {
  color: #adb5bd !important;
}

.block-item-card label {
  font-weight: 700;
  color: #6c757d;
  display: inline-block;
  margin-bottom: 0;
}

.block-item-card .form-text {
  display: block;
  margin-top: 0;
}

.item-header-nav {
  cursor: pointer;
  text-align: center;
  width: 270px;
  display: inline-block;
  background: #ebebeb;
  padding: 10px 15px;
  font-weight: bold;
}

.item-header-nav.active {
  background: white !important;
  color: #bec500;
}

.item-block {
  display: block;
  width: 100% !important;
  clear: both;
}

.item-date {
  width: 15% !important;
  float: left;
  display: block;
  min-height: 1px;
}

.item-doctor {
  width: 25% !important;
  float: left;
  display: block;
  min-height: 1px;
}

.item-action {
  width: 25% !important;
  float: left;
  display: block;
  min-height: 1px;
  text-align: left !important;
}
.item-type {
  width: 15% !important;
  float: left;
  display: block;
  min-height: 1px;
  text-align: left !important;
}

.item-user {
  width: 15% !important;
  float: left;
  display: block;
  min-height: 1px;
}

</style>
